import apiClient from './apiClient';

export interface F10C {
  f10c_01: string; f10c_11: string; f10c_12: string; f10c_13: boolean;
  f10c_91: string; f10c_92: string | null; f10c_93: string;
}
export interface ListResponse { data: F10C[]; total: number; page: number; size: number; }
export interface ValidationError { field: string; message: string; }

export const remarkApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/remark', { params })).data;
  },
  async get(code: string): Promise<F10C> {
    return (await apiClient.get(`/api/remark/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { f10c_01: string; f10c_11: string; f10c_12: string; f10c_13: boolean }): Promise<F10C> {
    return (await apiClient.post('/api/remark', data)).data;
  },
  async update(code: string, data: { f10c_11: string; f10c_12: string; f10c_13: boolean }): Promise<F10C> {
    return (await apiClient.put(`/api/remark/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/remark/${encodeURIComponent(code)}`);
  },
};
